import type { VoucherListTotals } from '@/marketing/models/voucher';
import { formatCurrency } from '@/marketing/lib/formatters';

function KpiCard({ label, value, hint }: { label: string; value: string; hint: string }) {
  return (
    <div className="tw-rounded-lg tw-border tw-border-border tw-bg-card tw-px-4 tw-py-3">
      <div className="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-muted-foreground">
        {label}
      </div>
      <div className="tw-mt-1 tw-text-2xl tw-font-bold tw-leading-none tw-text-foreground">{value}</div>
      <div className="tw-mt-1 tw-text-xs tw-text-muted-foreground">{hint}</div>
    </div>
  );
}

interface VoucherKpiCardsProps {
  totals: VoucherListTotals;
  currency: string;
}

export function VoucherKpiCards({ totals, currency }: VoucherKpiCardsProps) {
  return (
    <div className="tw-grid tw-grid-cols-2 tw-gap-3 md:tw-grid-cols-5">
      <KpiCard label="Active codes" value={String(totals.activeCodes)} hint={`${totals.disabledCodes} disabled`} />
      <KpiCard label="Redemptions" value={String(totals.redemptions)} hint="Lifetime, all codes" />
      <KpiCard label="Orders" value={String(totals.orderCount)} hint="Completed, commission base" />
      <KpiCard
        label="Attributed revenue"
        value={formatCurrency(totals.revenueTotal, currency)}
        hint="Selected period"
      />
      <KpiCard
        label="Commission"
        value={formatCurrency(totals.commissionTotal, currency)}
        hint={`${formatCurrency(totals.commissionAccrued, currency)} accrued`}
      />
    </div>
  );
}
